export default __webpack_public_path__ + "static/media/banner_img_3.7e153af2.png";